import { render, staticRenderFns } from "./UserRegistration.vue?vue&type=template&id=74649419&scoped=true"
import script from "./UserRegistration.vue?vue&type=script&lang=js"
export * from "./UserRegistration.vue?vue&type=script&lang=js"
import style0 from "./UserRegistration.vue?vue&type=style&index=0&id=74649419&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74649419",
  null
  
)

export default component.exports